import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDragCenterCursor = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 104 104",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M53.1647 48.2007L51.9749 48.0263C51.3251 47.9309 50.664 48.0977 50.137 48.4898L49.1723 49.2077C48.6456 49.5997 48.296 50.1852 48.2007 50.835L48.0263 52.0248C47.9309 52.6746 48.0977 53.3357 48.4898 53.8627L49.2077 54.8274C49.5999 55.3543 50.1852 55.7039 50.835 55.7993L52.0248 55.9737C52.6746 56.0691 53.3357 55.9023 53.8628 55.5102L54.8274 54.7923C55.3543 54.4001 55.7039 53.8148 55.7993 53.165L55.9738 51.9752C56.0691 51.3254 55.9023 50.6643 55.5102 50.1373L54.7923 49.1726C54.4001 48.6457 53.8148 48.2961 53.165 48.2007H53.1647Z" })
});
const ForwardRef = forwardRef(SvgDragCenterCursor);
export default ForwardRef;
